"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _core = require("@emotion/core");

var _themeUi = require("theme-ui");

var GlobalStyles = function GlobalStyles() {
  return (0, _themeUi.jsx)(_core.Global, {
    styles: (0, _themeUi.css)({
      '*': {
        WebkitFontSmoothing: 'antialiased !important',
        MozOsxFontSmoothing: 'grayscale !important',
        textRendering: 'optimizelegibility !important'
      },
      body: {
        fontFamily: function fontFamily(theme) {
          return theme.fonts.body;
        }
      }
    })
  });
};

var _default = GlobalStyles;
exports["default"] = _default;